/**
 * Working-quarter resolution.
 *
 * The quarter the operator is WORKING ON comes from the backend
 * (most recently created is_current snapshot) — NOT from today's date.
 * Final Q2 data gets uploaded in July; the app must not auto-jump to Q3
 * until a Q3 snapshot is explicitly started from the upload screen.
 *
 * `initWorkingQuarter()` is awaited once at app bootstrap (App.js) and
 * caches the result, so the existing synchronous `getCurrentQuarter()`
 * call sites keep working unchanged.
 */

function calendarQuarter() {
  const now = new Date();
  const month = now.getMonth(); // 0-indexed
  const year = now.getFullYear();
  if (month < 3) return { quarter: "Q1", year };
  if (month < 6) return { quarter: "Q2", year };
  if (month < 9) return { quarter: "Q3", year };
  return { quarter: "Q4", year };
}

let workingQuarter = null;

export async function initWorkingQuarter() {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/v2/snapshot-workflow/working-quarter`
    );
    if (res.ok) {
      const data = await res.json();
      if (data && data.quarter && data.year) {
        workingQuarter = { quarter: data.quarter, year: data.year };
      }
    }
  } catch (e) {
    // network hiccup — calendar fallback below
  }
  if (!workingQuarter) workingQuarter = calendarQuarter();
  return workingQuarter;
}

export function getCurrentQuarter() {
  return workingQuarter || calendarQuarter();
}
